@if (campaign.audit) {
	<div class="block">
		<span class="title">{{ 'campaigns.createdOn' | translate }}</span>
		<span>{{ campaign.audit.creationDate | dateFormat }}</span>
	</div>
}

@let repeatRule = campaign.settings.repeatRule;
@if (repeatRule && schedulerUtils.isCurrentlyRepeating(repeatRule) && !campaign.isTerminal()) {
	<ng-container *ngTemplateOutlet="repeatBlocks"></ng-container>
} @else {
	<ng-container *ngTemplateOutlet="nonRepeatBlocks"></ng-container>
}

<ng-template #repeatBlocks>
	<div class="block">
		<span class="title">{{ 'campaigns.startDate' | translate }}</span>
		{{
			!campaign.isScheduled() && !campaign.isWaitingForApproval() && campaign.info.startDate
				? (campaign.info.startDate | dateFormat)
				: '—'
		}}
	</div>
	<div class="block">
		@if (campaign.isTerminal()) {
			<span class="title">{{ 'campaigns.endDate' | translate }}</span>
			<span>
				{{ campaign.info.finishedDate ? (campaign.info.finishedDate | dateFormat) : '—' }}
			</span>
		} @else {
			<span class="title">{{ 'campaigns.endDateOfAllRuns' | translate }}</span>
			<span>
				{{ repeatRule?.endDate ? (repeatRule!.endDate | dateFormat) : ('campaigns.scheduler.nonStop' | translate) }}
			</span>
		}
	</div>
	<div class="block">
		<span class="scheduled-title">
			{{ 'campaigns.scheduledDate' | translate }}
			<alaris-icon
				[alarisTooltip]="schedulerUtils.displayRepeatRule(repeatRule!)"
				name="icon-info"
				class="repeat-icon"
			></alaris-icon>
		</span>
		@let nextRunAt = repeatRule?.nextRunAt;
		@if (campaign.isScheduled() || campaign.isWaitingForApproval()) {
			<span>{{ campaign.info.scheduled ? (campaign.info.scheduled | dateFormat) : '—' }}</span>
		} @else if (nextRunAt) {
			<span>
				{{ 'campaigns.scheduler.next' | translate }}
				@switch (schedulerUtils.getNextRunDay(nextRunAt)) {
					@case (CampaignNextRunDay.EMPTY) {
						—
					}
					@case (CampaignNextRunDay.TODAY) {
						{{ 'campaigns.scheduler.today' | translate | lowercase }},
						{{ nextRunAt | date: dateFormat.timeFormat }}
					}
					@case (CampaignNextRunDay.TOMORROW) {
						{{ 'campaigns.scheduler.tomorrow' | translate | lowercase }},
						{{ nextRunAt | date: dateFormat.timeFormat }}
					}
					@case (CampaignNextRunDay.OTHER) {
						{{ nextRunAt | dateFormat }}
					}
				}
			</span>
		}
	</div>
</ng-template>

<ng-template #nonRepeatBlocks>
	@if (campaign.info.status === CampaignStatus.SCHEDULED) {
		<div class="block">
			<span class="title">{{ 'campaigns.scheduledDate' | translate }}</span>
			<span>{{ campaign.info.scheduled | dateFormat }}</span>
		</div>
	} @else {
		<div class="block">
			<span class="title">{{ 'campaigns.startDate' | translate }}</span>
			{{ campaign.info.startDate ? (campaign.info.startDate | dateFormat) : '—' }}
		</div>
	}
	<div class="block">
		<span class="title">{{ 'campaigns.endDate' | translate }}</span>
		<span>
			{{ campaign.info.finishedDate ? (campaign.info.finishedDate | dateFormat) : '—' }}
		</span>
	</div>
</ng-template>
